import Hud from 'app/ui/Hud';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';

import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';

import { GAME_SFX_MAP_PROGRESSION } from 'app/constants/GameSFX';
import { FONT_TITLE, TIMER_TEXT_COLOUR, TIMER_SHADOW_COLOUR } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

class CutScene extends Phaser.State {
  init() {}

  preload(game) {}

  create(game) {
    this.game = game;

    this.background = this.game.make.image(0, 0, 'bg_laptop_screen');

    this.container = this.game.add.group();
    this.container.add(this.background);

    this.game.hud.activate({ id: Hud.CUTSCENE });

    this.createVideo();

    this.game.sounds.stopBackgroundMusic();

    this.btnSkip = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play' });
    this.btnSkip.anchor.set(0.5, 1);
    this.btnSkip.onInputDown.add(this.skipVideo, this);
    this.game.add.existing(this.btnSkip);

    this.game.windowEventController.handleWindowResize();
    this.game.scale.onSizeChange.add(this.positionContainer, this);
    this.positionContainer();
  }

  skipVideo() {
    this.game.controller.startCharacterSelect();
    this.game.track(AppTrackingEvents.SKIP_CUTSCENE);
  }

  createVideo() {
    this.video = this.game.add.video('cat_intro');
    this.video.play(false);
    this.video.onComplete.add(this.onVideoEnd, this);
    this.videoImage = this.video.addToWorld(250, 89, 0, 0, 435 / 540, 435 / 540);
    this.container.addChildAt(this.videoImage, 0);
  }

  onVideoEnd() {
    this.game.time.events.add(500, this.skipVideo, this).autoDestroy = true;
  }

  positionContainer() {
    const targetScale = this.game.width / this.background.width;
    this.container.scale.set(Math.max(1, targetScale));
    if (targetScale > 1) {
      this.container.x = (this.game.width - this.background.width * targetScale) / 2;
      this.container.y = 0;
    } else {
      this.container.x = (this.game.width - this.background.width) / 2;
      this.container.y = 0;
    }

    this.btnSkip.position.set(this.game.width * 0.5, this.game.height * 0.95);
    // this.background.scale.set(Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth));
    // this.background.position.set(0, 0);
  }

  /*
  ======================================================================================================
     START CUTSCENE
  ======================================================================================================
  */
  start() {}

  /*
  ==========================================================================================================
  UPDATE
  ==========================================================================================================
  */

  update(game) {}

  /*
  ======================================================================================================
     END CUTSCENE
  ======================================================================================================
  */

  shutdown(game) {
    this.game.scale.onSizeChange.remove(this.positionContainer, this);
    this.video.onComplete.remove(this.onVideoEnd, this);
    this.btnSkip.onInputDown.remove(this.skipVideo, this);

    this.video.destroy();
    this.videoImage.destroy();
    this.container.destroy();
    this.background.destroy();
  }
}

export default CutScene;
